import React from "react";
import { useSelector } from "react-redux";

const OverView = () => {
  const TourDetails = useSelector((state) => state.packageDetail.TourDetails);

  return (
    <div
      className="tab-pane fade show active"
      id="Overview"
      role="tabpanel"
      aria-labelledby="Overview-tab"
      dangerouslySetInnerHTML={{ __html: TourDetails?.Overview || "" }}
    />
  );
};

export default OverView;
